import { createAction, props } from '@ngrx/store';

export const saveVehicles = createAction(
    '[AUTH] save vehicles',
    props<{ value: any }>(),
);

export const getVehicles = createAction(
    '[AUTH] get Vehicles',
    props<{ value: any }>(),
);
